var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    width: "",
    height: "auto",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "_38_Question",
    "data-name": "38 Question"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.86 512a35.94 35.94 0 0 1 -35.55-40.61l12.84-98.12a40.81 40.81 0 0 1 11.56-23.47l338.29-338.29a39.42 39.42 0 0 1 55.67 0l81.82 81.82a39.42 39.42 0 0 1 0 55.67l-338.29 338.29a40.78 40.78 0 0 1 -23.47 11.56l-98.12 12.84a36.31 36.31 0 0 1 -4.75.31zm26.45-129.09-10.05 76.83 76.83-10.05 328.52-328.52-66.78-66.78z",
    fill: "#ff9aa3",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406.86 232.28a24.93 24.93 0 0 1 -17.68-7.28l-102.18-102.18a25 25 0 0 1 35.4-35.36l102.14 102.14a25 25 0 0 1 -17.68 42.68z",
    fill: "#ff9aa3",
    "data-original": "#000000",
    className: ""
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.8085ef070cfbda7d94c86a6a5630e6db.svg";
export { ForwardRef as ReactComponent };